//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { viewModelApi, pageviewDataApi, payDataApi } from '@/api/dashboard';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
export default {
  data: function data() {
    return {
      grid: {
        xl: 12,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 24
      },
      pageviewData: [],
      payData: []
    };
  },
  methods: {
    checkPermi: checkPermi,
    // 获取商品浏览量排行榜
    getPageviewData: function getPageviewData() {
      var _this = this;
      pageviewDataApi().then(function (res) {
        _this.pageviewData = res;
      });
    },
    // 获取商品支付排行榜
    getPayData: function getPayData() {
      var _this2 = this;
      payDataApi().then(function (res) {
        _this2.payData = res;
      });
    }
  },
  mounted: function mounted() {
    if (checkPermi(['merchant:statistics:home:product:pageview:ranking'])) this.getPageviewData();
    if (checkPermi(['merchant:statistics:home:product:pay:ranking'])) this.getPayData();
  }
};